import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';

export const useCancelPolicyQuery = () => {
  const axios = useAxios();

  const handleFetch = () => {
    return axios.get<AxiosResponse<CancelPolicyProps>>(ApiRoutes.cancelPolicy);
  };

  return useQuery(['cancel-policy'], handleFetch, {
    select: res => {
      return res.data.data;
    },
    keepPreviousData: true,
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
    staleTime: USE_QUERY_CONSTANTS.staleMs,
    refetchOnWindowFocus: USE_QUERY_CONSTANTS.refetchOnWindowFocus,
    retry: USE_QUERY_CONSTANTS.retry,
  });
};
